import React from 'react';
import Header from '../../headerone/Main';
import Committeeleft from './Committeeleft';
import Breadcrumb from '../../Breadcrumb/Main';
import { Row, Col, Table } from 'react-bootstrap';

function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="OBC CELL" />

            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">
                        <Row>
                            <Col md={3} className="c-left custom-padding-color mb-4">
                                <Committeeleft />
                            </Col>

                            <Col md={9} className="c-right">
                                <h3 className="c-headline mb-3">OBC CELL</h3>

                                <p className="caboutus c-lineheight2dot5">
                                    A special Cell to look into the affairs of Other Backward Class (OBC)
                                    students and employees of the Institute is constituted and functioning
                                    in the campus. It aims to foster a safe and respectful environment
                                    for all OBC students and employees, mitigating instances of
                                    discrimination. The cell encourages participation in career
                                    orientation programs and endeavors to address the diverse
                                    challenges faced by OBC students, aiming to enhance their
                                    psychological well-being and equip them with the necessary skills
                                    to navigate career choices.
                                </p>

                                <h4 className="mt-4 mb-3">OBC Liaison Officer</h4>

                                <Table bordered striped responsive>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Designation</th>
                                            <th>Role</th>
                                            <th>Contact</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Dr. N. Venkaiah</td>
                                            <td>Professor</td>
                                            <td>Liaison Officer</td>
                                            <td>0877 250 3035 / venkaiah@iittp.ac.in</td>
                                        </tr>
                                    </tbody>
                                </Table>

                                <h4 className="mt-5 mb-3">OBC Committee Members</h4>

                                <Table bordered striped responsive>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Designation</th>
                                            <th>Role</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Dr. N. Venkaiah</td>
                                            <td>Professor</td>
                                            <td>Chairman</td>
                                        </tr>
                                        <tr>
                                            <td>Dr. M. Nithyadharan</td>
                                            <td>Associate Professor</td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>Dr. Bibhuti Mary Kachhap</td>
                                            <td>Assistant Professor</td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>Dr. A. K. Suresh</td>
                                            <td>Junior Technical Superintendent</td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>Ms. Sneha S</td>
                                            <td>Ph.D. Scholar (PH22D503)</td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>Mr. Umesh Kumar Singh</td>
                                            <td>Assistant Registrar</td>
                                            <td>Member Secretary</td>
                                        </tr>
                                    </tbody>
                                </Table>

                                <h4 className="mt-5 mb-3">Objectives of the OBC Cell</h4>

                                <ol className="caboutus c-lineheight2dot5">
                                    <li><strong>1.</strong>
                                        To educate, empower the students and employees of OBC
                                        categories in the Institute to promote equal opportunity and to
                                        make use of the facilities extended by the Govt. and other agencies
                                        for their educational & occupational career.
                                    </li>

                                    <li><strong>2.</strong>
                                        To implement, monitor and evaluate continuously the reservation
                                        policy in Institute and plan measures for ensuring effective
                                        implementation of the policy and programs of the Government of
                                        India and Council of IITs.
                                    </li>

                                    <li><strong>3.</strong>
                                        To collect data regarding the implementation of the policies in respect
                                        of admissions, appointments to teaching and non-teaching positions
                                        in the Institute and analyze the data showing the trends and changes
                                        towards fulfilling the required quota.
                                    </li>

                                    <li>To organize orientation programs, workshops, and awareness
                                        campaigns to OBC Students about Scholarship, financial aid and
                                        career prospects.
                                    </li>
                                </ol>

                                <h4 className="mt-5 mb-3">Functions of the OBC Cell</h4>

                                <ol className="caboutus c-lineheight2dot5">
                                    <li><strong>1.</strong>
                                        To circulate the orders and other circulars issued by the Institute/
                                        Government of India and other statutory bodies and to collect
                                        regularly, on an annual basis, information regarding course-wise
                                        admission of candidates belonging to the Other Backward Classes in
                                        the Institute for different courses in prescribed form within the
                                        stipulated date, and to take follow-up works, where ever required.
                                    </li>

                                    <li><strong>2.</strong>
                                        To circulate the orders and other circulars issued by Government of
                                        India decisions in respect of appointment and promotion for faculty

                                        and staff posts in the Institute in suitable forms by a stipulated date
                                        and take follow up action where ever required.
                                    </li>

                                    <li><strong>3.</strong>
                                        To collect reports, orders and information issued by Government of
                                        India on the various aspects of Education, Training and Employment
                                        of other Backward Classes candidates for evolving new Policies or
                                        modifying existing policies.
                                    </li>

                                    <li><strong>4.</strong>
                                        To analyses information so collected and prepare reports for onward
                                        transaction to the Ministry of Human Resource Development, Govt. of
                                        India, and such other authorities as and when required.
                                    </li>

                                    <li><strong>5.</strong>
                                        To access the requirement of remedial class on need basis for OBC
                                        students and implement the same
                                    </li>

                                    <li><strong>6.</strong>
                                        To co-ordinate through Institute with Govt. (State &amp; Central), and
                                        such other organizations to get Scholarship/freeship/other financial
                                        benefits for OBC students.
                                    </li>

                                    <li><strong>7.</strong>
                                        To deal with representations received from Other Backward Classes
                                        (OBC) regarding their admission, Scholarships, Recruitment,
                                        Promotion and other similar matters in the Institute.
                                    </li>

                                    <li><strong>8.</strong>
                                        To function as a Grievances Redress Cell for the grievances of OBC
                                        students, faculty and staff of the Institute and render them necessary
                                        help in solving their academic, research as well as administrative
                                        problems.
                                    </li>

                                    <li><strong>9.</strong>
                                        To maintain a database of candidates belonging to OBC in the
                                        Institute and co-ordinate with Placement Cell/ Career Development
                                        Cell to facilitate in placement service.
                                    </li>

                                    <li><strong>10.</strong>
                                        Any other works assigned by the Institute from time to promote
                                        higher education among OBC students and staff.
                                    </li>
                                </ol>


                                <p
                                    className="caboutus c-lineheight2dot5"
                                    style={{ textAlign: 'justify' }}
                                >
                                    The Committee meets at least once a year and discusses about OBC
                                    students admitted against reservation norms, admitted under Unreserved
                                    Category, complaints and reference reported by the students, faculty and
                                    staff any other related matter and issue.
                                </p>

                                <h4 className="mt-5 mb-3">Contact</h4>

                                <p className="caboutus">
                                    <strong>OBC Cell Email ID:</strong>{' '}
                                    <a href="mailto:obccell@iittp.ac.in">
                                        obccell@iittp.ac.in
                                    </a>
                                </p>

                                <h4 className="mt-4 mb-3">Important Link</h4>

                                <p className="caboutus">
                                    <strong>
                                        National Commission for Backward Classes (NCBC):
                                    </strong>
                                    <br />
                                    <a
                                        href="https://www.ncbc.nic.in/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        https://www.ncbc.nic.in/
                                    </a>
                                </p>
                            </Col>
                        </Row>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Main;